/*
  Zugo - kisa sureli firsatlar.

  Geri sayim: sunucuda bitis tarihi tutulmaz. Sayac, ziyaretcinin yerel
  gece yarisina kalan sureyi gosterir; boylece her gun kendiliginden
  24 saatten yeniden baslar ve "bitti ama kimse yenilemedi" durumu olusmaz.
*/
class ZugoCountdown extends HTMLElement {
  connectedCallback() {
    this.saat = this.querySelector('[data-saat]');
    this.dakika = this.querySelector('[data-dakika]');
    this.saniye = this.querySelector('[data-saniye]');
    if (!this.saat) return;

    this.guncelle();
    this.zamanlayici = setInterval(() => this.guncelle(), 1000);

    // Sekme arka planda uyuyunca sayac donuyor; geri gelince tazelenir.
    this.gorunurluk = () => !document.hidden && this.guncelle();
    document.addEventListener('visibilitychange', this.gorunurluk);
  }

  disconnectedCallback() {
    clearInterval(this.zamanlayici);
    document.removeEventListener('visibilitychange', this.gorunurluk);
  }

  guncelle() {
    const simdi = new Date();
    const geceYarisi = new Date(simdi);
    geceYarisi.setHours(24, 0, 0, 0);

    const kalanSaniye = Math.max(0, Math.floor((geceYarisi - simdi) / 1000));
    const ss = Math.floor(kalanSaniye / 3600);
    const dd = Math.floor((kalanSaniye % 3600) / 60);
    const sn = kalanSaniye % 60;

    const iki = (n) => String(n).padStart(2, '0');
    this.saat.textContent = iki(ss);
    this.dakika.textContent = iki(dd);
    this.saniye.textContent = iki(sn);
    this.setAttribute('aria-label', `${iki(ss)}:${iki(dd)}:${iki(sn)}`);
  }
}

if (!customElements.get('zugo-countdown')) {
  customElements.define('zugo-countdown', ZugoCountdown);
}

class ZugoFlashSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-track]');
    this.dots = this.querySelector('[data-dots]');
    this.arrows = [...this.querySelectorAll('[data-yon]')];
    if (!this.track) return;

    this.onScroll = this.debounce(() => this.durumGuncelle(), 90);
    this.track.addEventListener('scroll', this.onScroll, { passive: true });
    this.arrows.forEach((b) =>
      b.addEventListener('click', () => this.kaydir(b.dataset.yon === 'sonraki' ? 1 : -1))
    );

    if (window.ResizeObserver) {
      this.gozlemci = new ResizeObserver(this.debounce(() => this.noktalariKur(), 120));
      this.gozlemci.observe(this.track);
    }
    this.noktalariKur();
  }

  disconnectedCallback() {
    this.gozlemci?.disconnect();
    this.track?.removeEventListener('scroll', this.onScroll);
  }

  get sayfaGenisligi() {
    return this.track.clientWidth;
  }

  get sayfaSayisi() {
    return Math.max(1, Math.round(this.track.scrollWidth / this.sayfaGenisligi));
  }

  noktalariKur() {
    const adet = this.sayfaSayisi;
    const kontroller = this.querySelector('.zugo-flash__controls');
    if (kontroller) kontroller.hidden = adet < 2;
    if (adet < 2 || !this.dots) return;

    if (this.dots.children.length !== adet) {
      this.dots.innerHTML = '';
      for (let i = 0; i < adet; i += 1) {
        const n = document.createElement('button');
        n.type = 'button';
        n.className = 'zugo-flash__dot';
        n.setAttribute('aria-label', `${i + 1}`);
        n.addEventListener('click', () =>
          this.track.scrollTo({ left: i * this.sayfaGenisligi, behavior: 'smooth' })
        );
        this.dots.appendChild(n);
      }
    }
    this.durumGuncelle();
  }

  durumGuncelle() {
    const aktif = Math.round(this.track.scrollLeft / this.sayfaGenisligi);
    if (this.dots) {
      [...this.dots.children].forEach((d, i) =>
        d.setAttribute('aria-current', i === aktif ? 'true' : 'false')
      );
    }
    const son = this.sayfaSayisi - 1;
    this.arrows.forEach((b) => {
      b.disabled = b.dataset.yon === 'sonraki' ? aktif >= son : aktif <= 0;
    });
  }

  kaydir(yon) {
    this.track.scrollBy({ left: yon * this.sayfaGenisligi, behavior: 'smooth' });
  }

  debounce(fn, ms) {
    let t;
    return (...a) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, a), ms);
    };
  }
}

if (!customElements.get('zugo-flash-slider')) {
  customElements.define('zugo-flash-slider', ZugoFlashSlider);
}
